
export const MixPanelEvents = {
  webSession : 'Web Session',
  atpUpdate : 'Atp update'
}

export const MixPanelAtpSteps = {
  bannerClicked : 'Banner clicked',
 incomeFieldFocus : 'Income field - Focus',
 housingExpensesFieldFocus : 'Housing expenses field - Focus',
 incomeWhatIsButtonClicks : 'What is Income - Click',
 housingStatusClicks : 'Housing Type - Set',
 atpSubmit : 'Submit updated Atp changes',
 atpCancel : 'Cancel and reset Atp update',
 continueWithOutOfRange: 'Continue after salary out of range',
 updateOutOfRange:'Update income after salary out of range'
};

export const utmBannerParams = {
  utm_class: 'commercial',
  utm_medium:'banner',
  utm_source:'mysunbit',
}



// WEBPACK FOOTER //
// ./src/constants/mixpanel.js